import { get } from "@/helpers/api";

export const listarPessoas = function(selecionados, typed) {
  return new Promise((resolve, reject) => {
    get("funcionario").then(response => {
      const { data } = response.data.result;
      const itens = [];

      data.forEach(obj => {
        if (
          !selecionados.some(i => i == obj.funcionario_id) &&
          obj.pessoa_nome.toLowerCase().includes(typed.toLowerCase())
        ) {
          const dataToPush = {
            funcionario_id: obj.funcionario_id,
            pessoa_nome: obj.pessoa_nome
          };

          itens.push(dataToPush);
        }
      });
      resolve(itens);
    });
  });
};

export const recuperarSelecionados = function(selecionados) {
  const gerarNovaLista = (selecionados, encontrados) => {
    let novaListaEncontrados = [];

    selecionados.forEach(sel =>

      encontrados.map(enc => {
        if (enc.funcionario_id == sel) {
          novaListaEncontrados.push(Object.assign({}, {
              funcionario_id: enc.funcionario_id,
              pessoa_nome: enc.pessoa.pessoa_nome
          }))
        };
        return enc;
      })
    );
    return novaListaEncontrados;
  };

  const encontraSelecionados = (data, selecionados) => {
    const listaDeSelecionados = [];
    selecionados.forEach(sel =>
      data.forEach(i => {
        if (i.funcionario_id == sel) {
          listaDeSelecionados.push(i);
        }
        return i;
      })
    );
    return listaDeSelecionados;
  };

  const listaDeFuncionarios = () => {
    return new Promise((resolve, reject) => {
      get("funcionario").then(response => {

        const { data } = response.data.result;
        const encontrados = encontraSelecionados(data, selecionados);
        const itens  = gerarNovaLista(selecionados, encontrados);

        resolve(itens);
      });
    });
  };

  return listaDeFuncionarios().then(response => response);
}



// WEBPACK FOOTER //
// ./src/components/lead/listagem/funcoesFiltro.js